































































import { Component, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { Registration } from "../../models/authentication/registration.model";
import { IRegistrationResponse } from "../../models/interfaces/authentication/registration-response.interface";
import ValidationService from "../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../inversify.config";

const UserModule = namespace("userModule");

@Component({})
export default class RegisterForm extends Vue {
  @UserModule.Getter public registrationResponse: IRegistrationResponse;
  @UserModule.Action public register;

  public submitDisabled: boolean = false;

  private isBusy: boolean = false;
  private userRegistration = {} as Registration;
  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  private submitForm() {
    this.submitDisabled = true;
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        this.isBusy = true;
        this.register(this.userRegistration).then((result) => {
          this.submitDisabled = true;
        });
      } else {
        this.submitDisabled = false;
      }
    });
  }
}
